"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelnuovo-magra": {
    "d3c6b8b4": [{
      "hkey": "72d2323a",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "skipSearch": false
    }],
    "castelnuovo-paese": [{
      "hkey": "72d2323a",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3cf40e7d": [{
      "hkey": "61a242f3",
      "slug": "mollicciara-molino-del-piano",
      "name": "Mollicciara-Molino del Piano",
      "primary": true,
      "skipSearch": false
    }],
    "molicciara": [{
      "hkey": "61a242f3",
      "slug": "mollicciara-molino-del-piano",
      "name": "Mollicciara-Molino del Piano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a97aa355": [{
      "hkey": "6df38d9b",
      "slug": "collina-del-sole-palvotrisia",
      "name": "Collina del Sole-Palvotrisia",
      "primary": true,
      "skipSearch": false
    }],
    "palvotrisia": [{
      "hkey": "6df38d9b",
      "slug": "collina-del-sole-palvotrisia",
      "name": "Collina del Sole-Palvotrisia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;